module.exports = __webpack_public_path__ + "img/3.98725a1b.jpg";